export const company = {
  name: "Türkan Gıda ve Kimya Ürünleri",
  shortName: "Türkan Kimya",
  email: "info@turkankimya.com.tr",
  phone: "+90 553 690 72 91",
  phoneHref: "tel:+905536907291",
  hours: "09:00 - 18:00",
  address: "Adil Mah. Said Nursi Cad. No:31/A, Sultanbeyli/İstanbul",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1506.0971474950236!2d29.256321250338463!3d40.977226141851204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cad040ba7f98a3%3A0x67b5463cd413fbc8!2sAdil%2C%20Said%20Nursi%20Cd.%20NO%3A31%2C%2034935%20Sultanbeyli%2F%C4%B0stanbul!5e0!3m2!1sen!2str!4v1758461148510!5m2!1sen!2str",
  /**
   * Formspree form notifications: set the recipient in the Formspree dashboard
   * (https://formspree.io) and confirm the verification email.
   */
  formspreeEndpoint: "https://formspree.io/f/xppzgjkr",
  /**
   * Cloudflare Turnstile site key (public). Create a widget at
   * https://dash.cloudflare.com/?to=/:account/turnstile
   * Hostnames: turkankimya.com.tr, www.turkankimya.com.tr, localhost
   * Use Managed mode. Paste the matching Secret Key in Formspree →
   * form settings → CAPTCHA → Cloudflare Turnstile.
   */
  turnstileSiteKey: "0x4AAAAAAEy-X456azwXoRxQ",
  social: {
    instagram: "https://www.instagram.com/haydarceylan58/",
    facebook: "https://www.facebook.com/turkan.kimya/",
    linkedin:
      "https://www.linkedin.com/in/t%C3%BCrkan-kimya-ve-gida-san-tic-ltd-%C5%9Fti-610b4a256/",
    whatsapp: "https://wa.me/905536907291",
  },
};
